import { useState } from "react";
function ReviewForm({ onSubmit }) {
  const [text, setText] = useState("");
  const [rating, setRating] = useState(5);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!text.trim()) return;
    try {
      await onSubmit({ rating, text: text.trim() });
      setText("");
      setRating(5);
    } catch (err) {
      setError(err.message || "Failed to submit review");
    }
  };

  return (
    <form className="review-form" onSubmit={handleSubmit}>
      <h3>Write a Review</h3>
      {error && <p className="auth-error">{error}</p>}
      <textarea
        placeholder="Your review"
        value={text}
        onChange={(e) => setText(e.target.value)}
        required
        rows="3"
      />
      <div className="review-form-row">
        <label>
          Rating:
          <select value={rating} onChange={(e) => setRating(Number(e.target.value))}>
            {[1, 2, 3, 4, 5].map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>
        <button type="submit">Submit Review</button>
      </div>
    </form>
  );
}

export default ReviewForm;
